import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Ticket } from '@zero/shared/util-models';
import { Observable } from 'rxjs';
import { TicketsPageActions } from '../+state/ticket.actions';

import { ticketsFeature } from '../+state/ticket.reducer';
import * as TicketSelectors from '../+state/ticket.selectors';

@Injectable({ providedIn: 'root' })
export class TicketFacade {
  public unreadTicketsCount$ = this.store.select(ticketsFeature.selectUnreadTicketsCount);
  public unreadTicketsCountInitiallyLoaded$ = this.store.select(ticketsFeature.selectUnreadTicketsCountInitiallyLoaded);
  public unreadTicketsCountLoading$ = this.store.select(ticketsFeature.selectUnreadTicketsCountLoading);
  public tickets$ = this.store.select(TicketSelectors.selectTicketTickets);
  public ticketsHasNext$ = this.store.select(ticketsFeature.selectTicketsHasNext);
  public ticketsLoading$ = this.store.select(ticketsFeature.selectTicketsLoading);
  public ticketsInitiallyLoaded$ = this.store.select(ticketsFeature.selectTicketsInitiallyLoaded);
  public error$ = this.store.select(ticketsFeature.selectError);

  constructor(private readonly store: Store) {}

  public loadTickets(force = false, page?: number, size?: number, status?: 'OPEN' | 'CLOSED' | 'ALL') {
    this.store.dispatch(TicketsPageActions.loadTickets({ force, page, size, status }));
  }

  //TODO: remove with V5
  public loadTicketsDeprecated(force = false) {
    this.store.dispatch(TicketsPageActions.loadTicketsDeprecated({ force }));
  }

  public loadUnreadTickets(force = false) {
    this.store.dispatch(TicketsPageActions.loadUnreadTicketsCount({ force }));
  }

  public selectTicketById(id: number): Observable<Ticket> {
    return this.store.select(TicketSelectors.selectTicketById(id));
  }
}
